import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { UsersAdmin } from './SearchUsers/UsersAdmin';


const Users = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 style={{ marginBottom: 30, color:'#024b82' }}>Gestión de Usuarios</h3>
      </Col>
    </Row>
    <Row>
        <UsersAdmin />
    </Row>
  </Container>
);

export default Users;